export default {
    color: '#c6cbe1',
    urls: ['/access']
}
